import { api_log_managment_variable,get_axios_log_management,errorHandler } from "@/apis/variables.js";
var axios_instance_fetchAll = get_axios_log_management(api_log_managment_variable.SERVICE_LOG_MANAGEMENT_DETAILS);
var axios_instance_fetchAll_application_details = get_axios_log_management(api_log_managment_variable.SERVICE_LOG_MANAGEMENT_APPLICATION_NAMES);
const state = {
    entityWiseData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};
const getters={
    editMode:(state)=>{
        return state,editMode
    },
    record:(state)=>{
        return state.record
    }
}
const mutations={
    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
    setEditMode: (state, payload) => {
        state.editMode = payload.editMode;
        state.record = payload.record;
    }
}
const actions={
    async fetchLogManagmentDetails({commit},payload){
        try{
            commit("setSaving",true);
             console.log(payload)
            let res =await axios_instance_fetchAll.get("")
            commit("setSaveing",false);
            return res;
        }catch(error){
            throw errorHandler(error.response)
        }
    },
    async fetchLogManagmentApplicationDetails({commit},payload){
        try{
            commit("setSaving",true);
             console.log(payload)
            let res =await axios_instance_fetchAll_application_details.get("")
            commit("setSaveing",false);
            return res;
        }catch(error){
            throw errorHandler(error.response)
        }
    },
    async fetchLogManagmentDetailsOnApplicationName({commit},payload){
        try{
            commit("setSaving",true);
            let res =await axios_instance_fetchAll.get("",{
            params:{
                applicationName:JSON.stringify(payload)
            }})
            commit("setSaveing",false);
            return res;
        }catch(error){
            throw errorHandler(error.response)
        }
    },
    async fetchLogManagmentDetailsOnTagName({commit},payload){
        try{
            commit("setSaving",true);
            let res =await axios_instance_fetchAll.get("",{
            params:{
                tagName:JSON.stringify(payload)
            }})
            commit("setSaveing",false);
            return res;
        }catch(error){
            throw errorHandler(error.response)
        }
    },
    async fetchLogManagmentDetailsOnBothAppTag({commit},payload){
        try{
            commit("setSaving",true);
            let res =await axios_instance_fetchAll.get("",{
            params:{
                applicationName:JSON.stringify(payload.applicationName),
                tagName:JSON.stringify(payload.tagName)
            }})
            commit("setSaveing",false);
            return res;
        }catch(error){
            throw errorHandler(error.response)
        }
    },
    async fetchLogManagmentDetailsOnDate({commit},payload){
        try{
            commit("setSaving",true);
            let res =await axios_instance_fetchAll.get("",{
                params:{
                    date:payload
                }})
                commit("setSaveing",false);
                return res;
        }catch(error){
            throw errorHandler(error.response)
        }
    }

}
export default{  
    namespaced: true,
    actions,
    getters,
    state,
    mutations
}